// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[test]7.2-rc-12420(722a0c8590)-C05/06/2026-12:47:23-B05/06/2026-13:00:23' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[test]7.2-rc-12420(722a0c8590)-C05/06/2026-12:47:23-B05/06/2026-13:00:23",
  branch: "test",
  latestTag: "7.2-rc",
  revCount: "12420",
  shortHash: "722a0c8590",
  longHash: "722a0c859033fb44a487f1ef51a4c43637435b3d",
  dateCommit: "05/06/2026-12:47:23",
  dateBuild: "05/06/2026-13:00:23",
  buildType: "Ansible",
  } ;
